import React from 'react';
import { gql, useQuery } from '@apollo/client';
import IdInput from 'components/Filter/IdInput';
import { BooleanField, Datagrid, BooleanInput } from 'react-admin';
import List from 'components/List';
import LinkField from 'components/LinkField';
import IdField from 'components/IdField';
import LocationInput from 'components/LocationInput';
import UsingBlendedRateField from 'components/UsingBlendedRateField';
import RateSettingsBulkUploadActions from '../shared/RateSettingsBulkUploadActions';

const TEMPLATE_URL_QUERY = gql`
  query {
    locationRateSettingTemplateUrl
  }
`;

const LocationRateSettingListFilters = [
  <IdInput />,
  <LocationInput alwaysOn />,
  <BooleanInput alwaysOn source="active" />,
];

const LocationRateSettingList = () => {
  const { data: templateUrlData } = useQuery(TEMPLATE_URL_QUERY);
  const downloadUrl = templateUrlData?.locationRateSettingTemplateUrl ?? '';

  return (
    <List
      filters={LocationRateSettingListFilters}
      exporter={false}
      additionalActions={
        <RateSettingsBulkUploadActions
          accessResource="LocationRateSetting"
          downloadUrl={downloadUrl}
          uploadUrl="v3/admin/location_rate_settings/import"
        />
      }
    >
      <Datagrid bulkActionButtons={false}>
        <IdField />
        <LinkField label="Location ID" source="location_id" />
        <BooleanField source="active" />
        <BooleanField
          label="Track Unpaid Breaks"
          source="settings.track_unpaid_breaks"
          sortable={false}
        />
        <UsingBlendedRateField />
      </Datagrid>
    </List>
  );
};

LocationRateSettingList.query = gql`
  query locationRateSettings($input: LocationRateSettingQueryInput) {
    _locationRateSettingsMeta(input: $input) {
      count
    }
    locationRateSettings(input: $input) {
      id
      location {
        primary_billing_group {
          plan
        }
      }
      location_id
      active
      settings
    }
  }
`;

export default LocationRateSettingList;
